import { render, staticRenderFns } from "./UserWishlist.vue?vue&type=template&id=32576520"
import script from "./UserWishlist.vue?vue&type=script&lang=js"
export * from "./UserWishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports